import styled from "styled-components/macro";

export const FinalAssessmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: var(--containerSize);
  gap: 24px;
  margin-bottom: 24px;
`;
